<template>
  <div>
    <v-menu v-model="notificationMenuShow" v-if="incomingWebNotifications.length > 0" transition="scroll-y-transition"
      :close-on-content-click="false" offset-y :nudge-width="200">
      <template v-slot:activator="{ on, attrs }">
        <div v-if="incomingWebNotifications.length > 0" v-bind="attrs" v-on="on">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div class="v-btn-nav" v-on="on">
                <v-badge :content="incomingWebNotifications.length" color="red" overlap>
                  <v-icon color="secondary">
                    mdi-bell
                  </v-icon>
                </v-badge>
              </div>
            </template>
            <span>{{ $t('GeneralTranslations.Notifications') }}</span>
          </v-tooltip>
        </div>
      </template>
      <v-list class="v-list-scrollable py-3 px-4">
        <template v-for="(n, i) in incomingWebNotifications">
          <v-list-item :key="i">
            <v-list-item-icon class="mr-3">
                <v-icon>{{getNotificationIcon(n)}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="py-0">
              <v-list-item-title>
                <v-btn text class="text-transform-none" @click="onNotificationItemClick(n)">
                  <span
                    v-if="n.type == notificationTypeEnum.ServiceRequestCreated || n.type == notificationTypeEnum.ServiceRequestCompleted">
                    <span>{{ n.body }}</span>
                   {{$t('WebNotifications.ClickHereToViewIt')}}.
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.UnattendedEventEnded">
                    <span>{{ n.body }}</span>
                    <span
                      v-if="n.eventType != eventTypesEnum.ScheduledCall && n.eventType != eventTypesEnum.RealtimeCall">
                   {{$t('WebNotifications.ClickHereToAddAttendance')}}.

                    </span>
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.MaintenanceRequestCreated">
                    <span>{{ n.body }}</span>
                    {{$t('WebNotifications.ClickHereToView')}}.
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.MaintenanceRequestCompletionDeadline">
                    <span>{{ n.body }}</span>
                    {{$t('WebNotifications.ClickHereToView')}}.
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.MaintenanceRequestComment">
                    <span>{{ n.body }}</span>
                    {{$t('WebNotifications.ClickHereToView')}}.
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.FeedbackRequestCreated">
                    <span>{{ n.body }}</span>
                    {{$t('WebNotifications.ClickHereToView')}}.
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.VisitCreated">
                    <span>{{ n.body }}</span>
                    {{$t('WebNotifications.ClickHereToViewMore')}}.
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.DeviceAssigned">
                    <span>{{ n.body }}</span>
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.DeviceUnassigned">
                    <span>{{ n.body }}</span>
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.StaffAppResidentSuggestedUserStory">
                    <span>{{ n.body }}</span>
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.Message">
                    <span>New message from <b>{{n?.fromName}}</b> family member</span>
                  </span>
                  <span v-else-if="n.type == notificationTypeEnum.HomeMessage">
                    <span>{{ n.body }}</span>
                  </span>
                  <span v-else-if="n.type === notificationTypeEnum.TransferResident">
                    <span>{{ n.body }}</span>
                  </span>
                  <span v-else>
                    <span>{{ n.body }}</span>
                    {{$t('WebNotifications.ClickHereToView')}}.
                  </span>
                </v-btn>
                <v-btn title="Mark as read" icon class="float-right" @click="readNotification(n.id)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-1" v-if="i < incomingWebNotifications.length - 1" :key="i"></v-divider>
        </template>
      </v-list>
      <v-divider class="my-0 py-0 footer-divider"></v-divider>
      <v-row class="notifications-footer py-0 my-0">
        <v-col cols="12" lg="12" md="12" sm="12" class="py-1 mr-4">
          <v-btn class="footer-btn float-right" text @click="goToProfile()">
            <v-icon small>mdi-cog</v-icon>{{$t('WebNotifications.GoToSettings')}}
          </v-btn>
          <v-btn class="footer-btn float-right pr-2" text @click="readAllNotification()">
            <v-icon small>mdi-close-box-multiple</v-icon>{{$t('WebNotifications.MarkAllAsRead')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-menu>

    <div v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div class="v-btn-nav" v-on="on">
            <v-icon color="secondary">
              mdi-bell
            </v-icon>
          </div>
        </template>
        <span>{{ $t('GeneralTranslations.Notifications') }}</span>
      </v-tooltip>
    </div>

    <ConfirmDlg ref="confirmModalDlg"></ConfirmDlg>
    <ConfirmMessageDlg ref="confirmationModal" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { NotificationTypeEnum } from "@/enums/NotificationTypeEnum";
import { EventsTypes } from "@/enums/EventsTypes";
import firebase from 'firebase';
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { getNotificationIcon } from "@/utils/getNotificationIcon";
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";
import { FeatureFlags, isFeatureEnabled } from "@/consts/featureFlags";

export default {
  components: {
    ConfirmDlg
  },
  props: {
    value: Boolean
  },
  data() {
    return {
      notificationMenuShow: false,
      incomingWebNotifications: [],
      notificationTypeEnum: NotificationTypeEnum,
      eventTypesEnum: EventsTypes,
      onNotificationsUnsubscribe: null,
      onUserUnsubscribe: null,
      currentUser: null,
      lastFacilityChangeDialogForId: null 
    }
  },
  watch: {
    webNotifications(list) {
      this.incomingWebNotifications = list
    },
    user(data) {
      //deep copy
      this.currentUser = JSON.parse(JSON.stringify(data))
    },
    facilityChangeNotice: {
      handler: 'showRemoteFacilityDialogIfNeeded',
      immediate: true
    }
  },

  computed: {
    ...mapState({
      user: state => state.authModule.user,
      currentFacility: state => state.authModule.currentFacility,
      currentFacilityData: state => state.authModule.currentFacilityData,
      webNotifications: state => state.userModule.incomingWebNotifications,
      facilityChangeNotice: state => state.authModule.facilityChangeNotice,
    }),
    staffFamilyMessagingEnabled() {
      return isFeatureEnabled(this.currentFacilityData, FeatureFlags.staffFamilyMessagingEnabled);
    },
  },
  async created() {
    if (this.user.id) {
      await this.loadIncomingWebNotifications()
      await this.subscribeOnNotifications()
      await this.subscribeOnUserChanged()
    }
  },
  beforeDestroy() {
    if (this.onNotificationsUnsubscribe) {
      this.onNotificationsUnsubscribe()
    }

    if (this.onUserUnsubscribe) {
      this.onUserUnsubscribe()
    }
  },
  methods: {
    getNotificationIcon(notification){
      return getNotificationIcon(notification.type, notification?.eventType)
    },
    async loadIncomingWebNotifications() {
      await this.$store.dispatch("getIncomingWebNotifications");
    },
    async readNotification(notificationId) {
      this.incomingWebNotifications = this.incomingWebNotifications.filter(x => x.id != notificationId)
      const doc = await firebase.firestore().collection("notifications").doc(notificationId).get()
      const docData = doc.data()
      docData.readByStaffs = docData.readByStaffs || []
      docData.readByStaffs.push({ id: this.user.id, dateTime: new Date() })
      return await doc.ref.update({ readByStaffs: docData.readByStaffs })
    },

    async readAllNotification() {
      this.notificationMenuShow = false
      try {
        const notificationsIds = this.incomingWebNotifications.map(x => x.id)
        await this.$store.dispatch("readNotification", { notificationsIds: notificationsIds, readByUserId: this.user.id })
        this.incomingWebNotifications = []
      } catch (error) {
        console.error(error)
      }
    },
    async onNotificationItemClick(notification) {
      this.incomingWebNotifications = this.incomingWebNotifications.filter(x => x.id !== notification.id)

      if (notification.type === NotificationTypeEnum.ServiceRequestCreated) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/bookings-and-orders/${notification.serviceRequestId}` });
        })
      } else if (notification.type === NotificationTypeEnum.ServiceRequestCompleted) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/bookings-and-orders/${notification.serviceRequestId}` });
        })
      } else if (notification.type === NotificationTypeEnum.UnattendedEventEnded) {
        if (notification.eventType === EventsTypes.ScheduledCall || notification.eventType === EventsTypes.RealtimeCall) {
          await this.readNotification(notification.id)
        } else {
          this.notificationMenuShow = false
          this.readNotification(notification.id).then(() => {
            this.$router.push({ path: `/calendar/${notification.eventId}` });
          })
        }
      } else if (notification.type === NotificationTypeEnum.MaintenanceRequestCreated) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/maintenanceRequests/${notification.referenceId}` });
        })
      } else if (notification.type === NotificationTypeEnum.MaintenanceRequestCompletionDeadline) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/maintenanceRequests/${notification.referenceId}` });
        })
      } else if (notification.type === NotificationTypeEnum.MaintenanceRequestComment) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/maintenanceRequests/${notification.referenceId}` });
        })
      } else if (notification.type === NotificationTypeEnum.FeedbackRequestCreated) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/family-feedback-requests/${notification.referenceId}` });
        })
      } else if (notification.type === NotificationTypeEnum.VisitCreated) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/guestbook/${notification.guestbookFamilyVisitId}` });
        })
      }
      else if (notification.type === NotificationTypeEnum.BookingsAndOrdersComment) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/bookings-and-orders/${notification.serviceRequestId}` });
        })
      } 
      else if (notification.type === NotificationTypeEnum.StaffAppResidentUpcomingCall) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/calendar/${notification.referenceId}` });
        })
      }
      else if (notification.type === NotificationTypeEnum.StaffAppResidentSuggestedUserStory) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/residents/${notification.referenceId}` });
        })
      }
      else if (notification.type === NotificationTypeEnum.Message) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/family-members/${notification.fromId}` });
        })
      }
      else if (notification.type === NotificationTypeEnum.HomeMessage) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/family-members/${notification.channel}` });
        })
      }
       else if (notification.type === NotificationTypeEnum.FeedbackRequestClosed 
       || notification.type === NotificationTypeEnum.FeedbackRequestPending
       || notification.type === NotificationTypeEnum.FeedbackRequestNewMessage
       || notification.type === NotificationTypeEnum.FeedbackRequestStale) {
        this.notificationMenuShow = false
        this.readNotification(notification.id).then(() => {
          this.$router.push({ path: `/family-feedback-requests/${notification.docId}` });
        })
      }
      else {
        await this.readNotification(notification.id)
      }
    },
    goToProfile() {
      this.$router.push({ path: `/settings?tab=user-profile` });
      this.notificationMenuShow = false
    },
    async subscribeOnNotifications() {
      const query = firebase.firestore().collection("notifications")
        .where("facilityId", "==", this.currentFacility).where("to", "==", "staff")
        // request data that was created after start listening
        .where("dateTimeCreated", ">=", firebase.firestore.Timestamp.fromMillis(Date.now()))
        .orderBy("dateTimeCreated", "desc")

       this.onNotificationsUnsubscribe = query
         .onSnapshot((snapshot) => {
           snapshot.docChanges().forEach(async (change) => {
             if (change.type === "added") {
               const notification = { id: change.doc.id, ...change.doc.data() }
               if (this.isAllowForUser(notification, this.user.options.webNotifications)) {
                 console.log(`received new notification`)
                 this.incomingWebNotifications.unshift(notification)
               }
             }
           })
         },
         (err) => {
              if (err?.code === "permission-denied") {
                console.warn("[notifications] listener blocked by rules; retry soon");
                setTimeout(() => {
                  if (this.onNotificationsUnsubscribe) {
                    this.onNotificationsUnsubscribe();
                    this.onNotificationsUnsubscribe = null;
                  }
                  this.subscribeOnNotifications();
                }, 1000);
                return;
              }
              console.error(err);
            }
        )

       this.$store.state.authModule.onNotificationsUnsubscribe = this.onNotificationsUnsubscribe;
    },
    isAllowForUser(notification, userWebNotificationsOptions) {
      const userId = this.user.id;
      const isUserAdmin = [StaffAccessLevels.OrgAdmin, StaffAccessLevels.HomeAdmin].includes(this.user.accessLevel);
      const isMaintenanceUser = [StaffAccessLevels.MaintenanceAdmin, StaffAccessLevels.MaintenanceUser].includes(this.user.accessLevel);
      const isHomeUser = this.user.accessLevel === StaffAccessLevels.HomeUser;

      if(notification?.staffAppNotification === true){
        return false
      } if (!userWebNotificationsOptions.serviceRequestCreated && notification.type === NotificationTypeEnum.ServiceRequestCreated) {
        return false
      } if (!userWebNotificationsOptions.serviceRequestCompleted && notification.type === NotificationTypeEnum.ServiceRequestCompleted) {
        return false
      } if (!userWebNotificationsOptions.unattendedEventEnded && notification.type === NotificationTypeEnum.UnattendedEventEnded) {
        return false
      } if (!userWebNotificationsOptions.maintenanceRequestCreated && notification.type === NotificationTypeEnum.MaintenanceRequestCreated) {
        return false
      } if (!userWebNotificationsOptions.maintenanceRequestComment && notification.type === NotificationTypeEnum.MaintenanceRequestComment) {
        return false
      } if (!userWebNotificationsOptions.newFamilyFeedbackRequestSubmitted && notification.type === NotificationTypeEnum.FeedbackRequestCreated) {
        return false
      } if (!userWebNotificationsOptions.maintenanceRequestWarning && notification.type === NotificationTypeEnum.MaintenanceRequestCompletionDeadline) {
        return false
      } if (!userWebNotificationsOptions.deviceAssigned && notification.type === NotificationTypeEnum.DeviceAssigned) {
        return false
      } if (!userWebNotificationsOptions.deviceUnassigned && notification.type === NotificationTypeEnum.DeviceUnassigned) {
        return false
      } if (!userWebNotificationsOptions.visitToResidentCreated && notification.type === NotificationTypeEnum.VisitCreated) {
        return false
      } if (!userWebNotificationsOptions.bookingsAndOrdersComment && notification.type === NotificationTypeEnum.BookingsAndOrdersComment) {
        return false
      } if (!userWebNotificationsOptions.messagesFromFamily && notification.type === NotificationTypeEnum.Message && notification.from === 'family') {
        return false
      } if (!userWebNotificationsOptions.updatesADT && notification.type === NotificationTypeEnum.TransferResident) {
        return false
      } if(userWebNotificationsOptions.messagesFromFamily && notification.type === NotificationTypeEnum.Message && (isUserAdmin ? !isUserAdmin : !notification?.staffUserIds?.includes(userId))) {
        return false
      } if(notification.type === NotificationTypeEnum.HomeMessage && (!this.staffFamilyMessagingEnabled || !notification?.staffUserIds?.includes(userId))) {
        return false
      } if (isMaintenanceUser && notification.type === NotificationTypeEnum.StaffAppResidentSuggestedUserStory) {
        return false
      } if ((isMaintenanceUser || isHomeUser) && (
        notification.type === NotificationTypeEnum.FeedbackRequestCreated ||
        notification.type === NotificationTypeEnum.FeedbackRequestNewMessage ||
        notification.type === NotificationTypeEnum.FeedbackRequestStale ||
        notification.type === NotificationTypeEnum.FeedbackRequestClosed ||
        notification.type === NotificationTypeEnum.FeedbackRequestPending
      )) {
        // Maintenance users and Home Users should not receive any family feedback notifications
        return false
      } if(!userWebNotificationsOptions.familyFeedbackFamilyReplied && notification.type === NotificationTypeEnum.FeedbackRequestNewMessage) {
        return false
      } if(!userWebNotificationsOptions.familyFeedbackRequiresUpdate && notification.type === NotificationTypeEnum.FeedbackRequestStale && !isUserAdmin) {
        return false
      }
      return true
    },
    
    async subscribeOnUserChanged() {
      if(!this.user?.id) return

      this.onUserUnsubscribe = firebase.firestore().collection("users").doc(this.user.id)
        .onSnapshot(async (doc) => {
          const updatedUser = doc.data()

          if (!this.currentUser) {
            this.currentUser = JSON.parse(JSON.stringify(this.user))
          }

          // If web notification options changed, refresh user and reload notifications.
          if (this.currentUser && this.currentUser.options && !this.shallowEqual(this.currentUser?.options?.webNotifications, updatedUser?.options?.webNotifications)) {
            this.$store.dispatch("getUser").then(async () => {
              await this.loadIncomingWebNotifications()
            })
          }
          
        })
    },
    
    async showRemoteFacilityDialogIfNeeded() {
      const notice = this.facilityChangeNotice
      if (!notice) return
      if (this.lastFacilityChangeDialogForId === notice.to) return

      if (!this.$refs.confirmModalDlg) {
        await this.$nextTick()
        if (!this.$refs.confirmModalDlg) return
      }

      this.lastFacilityChangeDialogForId = notice.to
      await this.$refs.confirmModalDlg.open(
        null,
        this.$i18n.messages[this.$i18n.locale]['WebNotifications.FacilityChangedText'],
        false,
        null,
        { noconfirm: true, yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Ok'], isPersistent: true }
      )
      this.$store.commit('clearFacilityChangeNotice')
    },

    shallowEqual(object1, object2) {
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);
      if (keys1.length !== keys2.length) {
        return false;
      }
      for (const key of keys1) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }
      return true;
    },
  }
};
</script>

<style scoped>
.v-menu__content {
  margin-top: 10px;
}

.text-transform-none {
  text-transform: none;
}

.display-block {
  display: block;
}

.notifications-footer {
  background-color: #ebebeb;
}

.footer-btn {
  height: 24px !important;
  color: gray !important;
  text-transform: none;
}

.v-divider.footer-divider {
  border-color: lightgray;
}
</style>
